import React, { useState } from 'react';
import { X, UserPlus, Mail } from 'lucide-react';
import { useAdminData } from '../contexts/AdminDataContext';
interface UserCreateDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: () => void;
}
const UserCreateDrawer: React.FC<UserCreateDrawerProps> = ({
  isOpen,
  onClose,
  onSuccess
}) => {
  const {
    createUser
  } = useAdminData();
  const [formData, setFormData] = useState({
    nome: '',
    cognome: '',
    email: '',
    luogo: '',
    obiettivi: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    createUser({
      avatar: `https://i.pravatar.cc/150?img=${Math.floor(Math.random() * 70)}`,
      nome: formData.nome,
      cognome: formData.cognome,
      email: formData.email,
      luogo: formData.luogo,
      obiettivi: formData.obiettivi,
      creditiDiamanteOttenuti: 0,
      creditiDiamanteSpesi: 0,
      creditiStellaOttenuti: 0,
      creditiStellaSpesi: 0,
      claimFatti: 0,
      dataIscrizione: new Date().toISOString().split('T')[0],
      status: 'active'
    });
    setFormData({
      nome: '',
      cognome: '',
      email: '',
      luogo: '',
      obiettivi: ''
    });
    onSuccess?.();
    onClose();
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  if (!isOpen) return null;
  return <>
      {/* Backdrop with blur */}
      <div className="fixed inset-0 bg-black/20 backdrop-blur-sm z-40" onClick={onClose} data-id="element-1662" />

      {/* Drawer */}
      <div className={`fixed top-0 right-0 h-full w-full sm:w-[500px] bg-white shadow-2xl z-50 overflow-y-auto transition-transform duration-300 ease-in-out ${isOpen ? 'transform-none' : 'translate-x-full'}`} data-id="element-1663">
        <div className="p-6" data-id="element-1664">
          {/* Header */}
          <div className="flex items-center justify-between mb-6 pb-4 border-b border-gray-200" data-id="element-1665">
            <div data-id="element-1666">
              <h2 className="text-xl font-semibold text-gray-900" data-id="element-1667">
                Aggiungi Nuovo Utente
              </h2>
              <p className="text-sm font-normal text-gray-600 mt-1" data-id="element-1668">
                Invita un nuovo utente sulla piattaforma
              </p>
            </div>
            <button onClick={onClose} className="rounded-full p-2 hover:bg-gray-100 transition-colors" data-id="element-1669">
              <X className="h-5 w-5 text-gray-500" data-id="element-1670" />
            </button>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-5" data-id="element-1671">
            {/* Nome e Cognome */}
            <div className="grid grid-cols-2 gap-4" data-id="element-1672">
              <div data-id="element-1673">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1674">
                  Nome <span className="text-red-500" data-id="element-1675">*</span>
                </label>
                <input type="text" name="nome" value={formData.nome} onChange={handleChange} required placeholder="Es. Mario" className="w-full px-4 py-2 border border-gray-300 rounded-lg text-sm font-normal focus:ring-2 focus:ring-green-600 focus:border-transparent" data-id="element-1676" />
              </div>

              <div data-id="element-1677">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1678">
                  Cognome <span className="text-red-500" data-id="element-1679">*</span>
                </label>
                <input type="text" name="cognome" value={formData.cognome} onChange={handleChange} required placeholder="Es. Rossi" className="w-full px-4 py-2 border border-gray-300 rounded-lg text-sm font-normal focus:ring-2 focus:ring-green-600 focus:border-transparent" data-id="element-1680" />
              </div>
            </div>

            {/* Email */}
            <div data-id="element-1681">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1682">
                Email <span className="text-red-500" data-id="element-1683">*</span>
              </label>
              <input type="email" name="email" value={formData.email} onChange={handleChange} required placeholder="mario.rossi@email.it" className="w-full px-4 py-2 border border-gray-300 rounded-lg text-sm font-normal focus:ring-2 focus:ring-green-600 focus:border-transparent" data-id="element-1684" />
              <p className="text-sm font-normal text-gray-500 mt-1" data-id="element-1685">
                L'utente riceverà un'email di invito a questo indirizzo
              </p>
            </div>

            {/* Luogo */}
            <div data-id="element-1686">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1687">
                Città
              </label>
              <input type="text" name="luogo" value={formData.luogo} onChange={handleChange} placeholder="Es. Milano" className="w-full px-4 py-2 border border-gray-300 rounded-lg text-sm font-normal focus:ring-2 focus:ring-green-600 focus:border-transparent" data-id="element-1688" />
            </div>

            {/* Obiettivi */}
            <div data-id="element-1689">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1690">
                Obiettivi Sostenibilità
              </label>
              <select name="obiettivi" value={formData.obiettivi} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg text-sm font-normal focus:ring-2 focus:ring-green-600 focus:border-transparent" data-id="element-1691">
                <option value="" data-id="element-1692">Seleziona un obiettivo...</option>
                <option value="Ridurre plastica" data-id="element-1693">Ridurre plastica</option>
                <option value="Vita sostenibile" data-id="element-1694">Vita sostenibile</option>
                <option value="Zero waste" data-id="element-1695">Zero waste</option>
                <option value="Cosmetici naturali" data-id="element-1696">Cosmetici naturali</option>
                <option value="Mobilità green" data-id="element-1697">Mobilità green</option>
                <option value="Alimentazione bio" data-id="element-1698">Alimentazione bio</option>
                <option value="Energia rinnovabile" data-id="element-1699">Energia rinnovabile</option>
                <option value="Ridurre sprechi" data-id="element-1700">Ridurre sprechi</option>
                <option value="Vita green" data-id="element-1701">Vita green</option>
                <option value="Riciclo attivo" data-id="element-1702">Riciclo attivo</option>
              </select>
            </div>

            {/* Info Box */}
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4" data-id="element-1703">
              <div className="flex items-start gap-3" data-id="element-1704">
                <Mail className="h-5 w-5 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-1705" />
                <div data-id="element-1706">
                  <h4 className="font-semibold text-blue-900 mb-1 text-sm" data-id="element-1707">
                    Email di Invito
                  </h4>
                  <p className="text-sm font-normal text-blue-700" data-id="element-1708">
                    Dopo aver creato l'utente, verrà inviata automaticamente
                    un'email di invito con le istruzioni per accedere alla
                    piattaforma Greenback.
                  </p>
                </div>
              </div>
            </div>

            {/* Actions */}
            <div className="flex gap-3 pt-4 border-t border-gray-200" data-id="element-1709">
              <button type="button" onClick={onClose} className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors" data-id="element-1710">
                Annulla
              </button>
              <button type="submit" className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg text-sm font-medium hover:bg-green-700 transition-colors" data-id="element-1711">
                <UserPlus className="h-4 w-4" data-id="element-1712" />
                Crea e Invia Invito
              </button>
            </div>
          </form>
        </div>
      </div>
    </>;
};
export default UserCreateDrawer;